<template>
    <div class="booking-summary">
        <div class="card-header">
            <h2 class="card-title">{{ event.name }}</h2>
        </div>

        <div
                v-if="booking.period"
                class="card-body">
            <div class="card-text">

                <div class="row">
                    <div class="col-8 text-truncate">
                        <img v-if="inPosMode()"
                             src="../assets/img/icon-black-2x.png"
                             alt="Locker" class="mr-1">
                        <img v-else
                             src="../assets/img/icon-black.png"
                             srcset="../assets/img/icon-black.png 1x, ../assets/img/icon-black-2x.png 2x, ../assets/img/icon-black-3x.png 3x"
                             alt="Locker" class="mr-1">
                        {{ getPeriodText(booking.period, 'name') }}
                    </div>

                    <div class="col text-right">
                        <span v-if="totalAmount">
                            {{ $n(totalAmount, 'currency') }}
                        </span>
                    </div>
                </div>

                <small class="d-block mt-2">
                    {{ $t('from') }}: {{ booking.period.start | moment('dddd D MMMM - HH:mm') }} <br>
                    {{ $t('till') }}: {{ booking.period.end | moment('dddd D MMMM - HH:mm') }}
                </small>

                <small
                        v-if="getPeriodText(booking.period, 'description')"
                        class="d-block mt-2"
                >
                    <em>{{ getPeriodText(booking.period, 'description') }}</em>
                </small>

                <ul class="list-comma">
                    <li
                            v-for="(line, index) in booking.linesWithQuantity"
                            v-bind:key="index"
                    >
                        <small v-if="+line.quantity !== 0">{{ line.quantity }}x {{ line.name }}</small>
                    </li>
                </ul>
            </div>

            <hr class="mb-1">
        </div>

        <error-list></error-list>
    </div>
</template>

<script>
    import translationMixin from '../mixins/translationMixin';
    import posMixin from '../mixins/posMixin';

    export default {
        mixins: [translationMixin, posMixin],

        props: [
            'event',
            'booking'
        ],

        computed: {
            /**
             * Get total amount.
             *
             * @return Number
             */
            totalAmount() {
                return this.booking.calculateTotalAmount(this.event);
            }
        }
    }
</script>
